import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PageBase, SetupLocationInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common/components/datatable/datatable';
import moment from 'moment';

@Component({
  styleUrls: ['./SetupLocations.css'],
  selector: 'SetupLocations',
  templateUrl: './SetupLocations.component.html',
})
export class SetupLocationsComponent extends PageBase implements OnInit {
  @ViewChild("tblEntityEvents", { static: false }) tblEntityEvents: T4DatatableWidget;
  public isLoading: boolean = false;
  public isRetrieving: boolean = false;
  public setupLocations: SetupLocationInfo[] = [];

  public fileLoading: boolean = false;

  constructor(el: ElementRef, private router: Router) {
      super(el, "Settings");
    }

  async ngOnInit() {
    await this.loadData();
  }

  public async loadData() {
    this.isLoading = true;
    this.isRetrieving = true;
    this.setupLocations = await this.Api.get<SetupLocationInfo[]>("/Settings/GetSetupLocations", {});
    this.isRetrieving = false;
    this.isLoading = false;
  }

  public async update(row: SetupLocationInfo, operation: number) {
     
    if (operation == 1) {
      var x = await this.UI.confirm("T4.Settings.SetupLocations.ConfirmActiveInApp", "Confirm app status", "T4.Settings.SetupLocations.ConfirmActiveInAppMessage", "Do you want to update the status of app availability for customer: {0} ?", null, [row.Location]);
      if (x) {
        if (row.IsActiveInApp === true) {
          row.IsActiveInApp = false;
          row.AvailableOnline = false;
        }
        else if (row.IsActiveInApp === false) {
          row.IsActiveInApp = true;
          row.AvailableOnline = true;
        }
        else {
          row.IsActiveInApp = false;
        }
        await this.updateSettings(row, operation, row.IsActiveInApp);
      }
      else {
        return;
      }
    }
    else if (operation == 2) {
      var x = await this.UI.confirm("T4.Settings.SetupLocations.ConfirmActiveInTysse", "Confirm tysse app status", "T4.Settings.SetupLocations.ConfirmActiveInTysseMessage", "Do you want to update the status of app availability for customer: {0} in tysse ?", null, [row.Location]);
      if (x) {
        if (row.IsActiveInTysse === true) {
          row.IsActiveInTysse = false;
        }
        else if (row.IsActiveInTysse === false) {
          row.IsActiveInTysse = true;
        }
        else {
          row.IsActiveInTysse = false;
        }
        await this.updateSettings(row, operation, row.IsActiveInTysse);
      }
      else {
        return;
      }
    }
    else if (operation == 3) {
      var x = await this.UI.confirm("T4.Settings.SetupLocations.ConfirmActiveInBrenderupRental", "Confirm brenderuprental app status", "T4.Settings.SetupLocations.ConfirmActiveInBrenderupRentalMessage", "Do you want to update the status of app availability for customer: {0} in brenderuprental ?", null, [row.Location]);
      if (x) {
        if (row.IsActiveInBrenderupRental === true) {
          row.IsActiveInBrenderupRental = false;
        }
        else if (row.IsActiveInBrenderupRental === false) {
          row.IsActiveInBrenderupRental = true;
        }
        else {
          row.IsActiveInBrenderupRental = false;
        }
        await this.updateSettings(row, operation, row.IsActiveInBrenderupRental);
      }
      else {
        return;
      }
    }
    else if (operation == 4) {
      var x = await this.UI.confirm("T4.Settings.SetupLocations.ConfirmAvailableOnline", "Confirm online availability", "T4.Settings.SetupLocations.ConfirmAvailableOnlineMessage", "Do you want to update the status of online availability for customer: {0} ?", null, [row.Location]);
      if (x) {
        if (row.AvailableOnline === true) {
          row.AvailableOnline = false;
        }
        else if (row.AvailableOnline === false) {
          row.AvailableOnline = true;
        }
        else {
          row.AvailableOnline = false;
        }
        await this.updateSettings(row, operation, row.AvailableOnline);
      }
      else {
        return;
      }
    }
    else if (operation == 5) {
      var x = await this.UI.confirm("T4.Settings.SetupLocations.ConfirmAllTrailersAvailability", "Confirm online availability of all trailers", "T4.Settings.SetupLocations.ConfirmAllTrailersAvailabilityMessage", "Do you want to update the status of online availability of all trailers for customer: {0} ?", null, [row.Location]);
      if (x) {
        if (row.AllTrailersAvailableOnline === true) {
          row.AllTrailersAvailableOnline = false;
          row.OnlineTrailerCount = 0;
        }
        else if (row.AllTrailersAvailableOnline === false) {
          row.AllTrailersAvailableOnline = true;
          row.OnlineTrailerCount = row.TotalTrailerCount;
          row.NotOnlineTrailers = [];
        }
        else {
          row.AllTrailersAvailableOnline = false;
        }
        await this.updateSettings(row, operation, row.AllTrailersAvailableOnline);
      }
      else {
        return;
      }
    }
  }

  public async updateSettings(row: SetupLocationInfo, operation: number, value: boolean) {
    this.isLoading = true;
    var ret = await this.Api.get<boolean>("/Settings/UpdateSetupLocations", { contextId: row.ContextId, value: value, operation: operation });
    if (ret) {
      this.UI.alert("T4.Settings.SetupLocations.SuccessMsgTitle", "Success!", "T4.Settings.SetupLocations.SuccessMsgEmpty", "The settings is updated successfully.");
    }
    else {
      this.UI.alert("T4.Settings.SetupLocations.ErrorMsgTitle", "Failed!", "T4.Settings.SetupLocations.ErrorMsgEmpty", "There was an issue with updating the settings. Please try again later.");
    }
    this.isLoading = false;
  }


  public async downloadFile() {
    this.fileLoading = true;

    const currentTime = new Date();
    const formattedTime = currentTime.toISOString().replace('T', ' ').slice(0, 19);
    var data = await this.Api.get<any[]>("DataService/GetReport", { reportName: 'MyGoogleBusinessReport', from: formattedTime, to: formattedTime });

    console.log(data);

    var exportHeaders: string[] = Object.keys(data[0]);

    var content = "";

    for (var i = 0; i < exportHeaders.length; i++)
      content += exportHeaders[i] + ';';
    content += "\r\n";

    for (var i = 0; i < data.length; i++) {
      for (var j = 0; j < exportHeaders.length; j++) {
        var property = exportHeaders[j];
        var val;

          val = data[i][property];

        // Process the value based on its type and append to content
        if (val !== undefined && val !== null) {
          if (val instanceof Date) {
            content += val.toISOString();
          } else if (val instanceof moment) {
            content += (val as moment.Moment).format("YYYY-MM-DD HH:mm");
          } else if (typeof val === "string") {
            content += "\"" + val.replace(/\r?\n|\r/g, "").replace("\"", "\"\"") + "\"";
          } else if (typeof val === "number") {
            content += val.toString().replace(".", ",");
          } else if (val.toString) {
            content += val.toString();
          }
        }
        content += ";";
      }
      content += "\r\n";
    }

    var blob = new Blob([content.replace(".", ",")], {
      type: "text/csv;charset=utf-8"
    });

    var filename = "MyGoogleBuisnessReport";

    saveAs(blob, filename);


    this.fileLoading = false;
  }

}
